<template>
  <div id="goTop">
    <Header :url="url"></Header>
    <van-swipe :autoplay="3000" style="margin-top:1rem">
      <van-swipe-item
        v-for="(image, index) in images"
        @click="tolink(image)"
        :key="index"
      >
        <img class="banner" :src="image.posterImg" alt />
      </van-swipe-item>
    </van-swipe>
    <div class="index">
      <img style="width:100%" src="/static/img/index/index1.jpg?v=1" alt />
      <div class="content">
        <div class="title">快速注册,免费体验</div>
        <div class="ipt-div">
          <span class="icon-span">
            <img
              style="margin-left:0.05rem;height:70%;width:70%"
              src="/static/img/index/phone.png"
              alt
            />
          </span>
          <div>
            <input
              type="text"
              autocomplete="off"
              v-model="phoneValue"
              maxlength="11"
              placeholder="请输入您的手机号"
            />
          </div>
        </div>
        <div class="ipt-div">
          <span class="icon-span">
            <img src="/static/img/index/code.png" alt />
          </span>
          <div>
            <input
              maxlength="6"
              autocomplete="off"
              v-model="codeMsgValue"
              type="text"
              placeholder="请输入验证码"
            />
            <span
              v-if="!codeNumber"
              @click="getVerificationCode"
              class="send-code"
              >{{ codeButton }}</span
            >
            <span v-if="codeNumber" class="send-code">{{ codeButton }}</span>
          </div>
        </div>
        <div class="ipt-div">
          <span class="icon-span">
            <img src="/static/img/index/password.png" alt />
          </span>
          <div>
            <input
              autocomplete="off"
              style="width:100%"
              type="password"
              v-model="passWordValue"
              maxlength="20"
              placeholder="请输入至少六位密码，区分大小写"
            />
          </div>
        </div>
        <div class="ipt-div">
          <span class="icon-span">
            <img src="/static/img/index/sure-password.png" alt />
          </span>
          <div>
            <input
              type="password"
              autocomplete="off"
              v-model="surePwd"
              maxlength="20"
              placeholder="确认密码"
            />
          </div>
        </div>
        <div @click="registerNow" class="btnClick">去注册</div>
        <div
          @click="toLogin"
          style="color: rgb(11, 167, 255);margin:0.3rem 0 0.2rem 0"
        >
          使用已有账号登录
        </div>
        <div class="agree" style="text-align:left">
          <input
            @click="agreeClick"
            class="check"
            value
            v-if="agree"
            name="0"
            type="checkBox"
          />
          <input
            @click="agreeClick"
            class="check"
            value
            v-if="!agree"
            name="1"
            type="checkBox"
          />
          <span style="margin-left:0.05rem">
            同意并遵守
            <router-link style="color:rgba(11, 167, 255, 1)" to="/agreezc"
              >《用户服务协议》</router-link
            >和
            <router-link style="color:rgba(11, 167, 255, 1)" to="/agreeys"
              >《隐私及信息保护政策》</router-link
            >
          </span>
        </div>
      </div>
      <img style="width:100%" src="/static/img/index/indexTitle1.png" alt />
      <ul
        style="overflow:hidden;background:#fafafa;margin:0;padding:0px 0.1rem 10px;"
      >
        <li class="list-img" v-for="(item, index) in priceList" @ :key="index">
          <div style="padding:5px;box-sizing:border-box" @click="toBuy(item)">
            <img
              style="width:20%;transform: translateY(50%);"
              :src="item.flagUrl"
              alt=""
            />
            <img
              style="box-shadow: 0 0 5px rgba(0,0,0,0.1);"
              :src="item.url"
              alt=""
            />
          </div>
        </li>
      </ul>
      <img style="width:100%" src="/static/img/index/indexTitle2.png" alt />
      <ul
        style="overflow:hidden;background:#fafafa;margin:0;padding:0px 0.1rem 10px;"
      >
        <li
          class="list-img list-img2"
          v-for="(item, index) in priceList1"
          :key="index"
        >
          <div style="padding:5px;box-sizing:border-box" @click="toBuy(item)">
            <img
              style="width:20%;transform: translateY(50%);"
              :src="item.flagUrl"
              alt=""
            />
            <img
              style="box-shadow: 0 0 5px rgba(0,0,0,0.1);"
              :src="item.url"
              alt=""
            />
          </div>
        </li>
      </ul>
      <img style="width:100%" src="/static/img/index/index2.jpg" alt />
      <img style="width:100%" src="/static/img/index/index3.jpg" alt />
      <img style="width:100%" src="/static/img/index/index4.jpg" alt />
      <!-- <img style="width:100%" src="/static/img/index/index5.jpg" alt /> -->
      <img src="/static/img/index/registered-bottom.jpg" alt />
    </div>
    <!-- <a href="#goTop" style="color:#666">
      <p style="padding:10px;background:#ccc;margin:0  ">
        回到顶部
      </p>
    </a> -->
    <div
      v-show="liderValidation"
      :style="{ height: windowHeight + 'px' }"
      class="maskStyle"
    >
      <slider
        :phoneValue="phoneValue"
        :clickBtnNum="1"
        :slider="slider"
        @sliderSuccess="sliderSuccess"
        ref="slider"
      ></slider>
    </div>
    <div v-if="scrollTop" @click="scrollToTop" class="to-top">
      <img src="/static/img/icon/toTop.png" alt />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import slider from '@/components/slider'
import {
  registered,
  channelNo,
  getSysPosterConfigList,
  linkToProgram,
  adRecordBanner
} from '@/api/land.js'
import Header from '@/components/Header'
import { throttle, getCookie, debounce } from '@/util/util'
export default {
  data () {
    return {
      images: [
        // "/static/img/index/new-year-banner1.jpg",
        // "/static/img/index/new-year-banner.jpg",
        // "/static/img/index/laxin.jpg",
        { posterImg: '/static/img/index/banner1.png' },
        { posterImg: '/static/img/index/banner2.png' }
      ],
      priceList: [
        {
          country: 0,
          url: '/static/img/indexBuy/yg.jpg',
          flagUrl: '/static/img/indexBuy/yg-f.png'
        },
        {
          country: 2,
          url: '/static/img/indexBuy/dg.jpg',
          flagUrl: '/static/img/indexBuy/dg-f.png'
        },
        {
          country: 1,
          url: '/static/img/indexBuy/fg.jpg',
          flagUrl: '/static/img/indexBuy/fg-f.png'
        },
        {
          country: 4,
          url: '/static/img/indexBuy/xby.jpg',
          flagUrl: '/static/img/indexBuy/xby-f.png'
        },
        {
          country: 3,
          url: '/static/img/indexBuy/ydl.jpg',
          flagUrl: '/static/img/indexBuy/ydl-f.png'
        },
        {
          country: 8,
          url: '/static/img/indexBuy/adl.jpg',
          flagUrl: '/static/img/indexBuy/adl-f.png'
        },
        {
          country: 5,
          url: '/static/img/indexBuy/bl.png',
          flagUrl: '/static/img/indexBuy/bl-f.png'
        },
        {
          country: 7,
          url: '/static/img/indexBuy/hl.jpg?v=0',
          flagUrl: '/static/img/indexBuy/hl-f.png'
        },
        {
          country: 11,
          url: '/static/img/indexBuy/shate.jpg?v=1',
          flagUrl: '/static/img/indexBuy/shate-f.png'
        },
        {
          country: 12,
          url: '/static/img/indexBuy/alianqiu.jpg?v=1',
          flagUrl: '/static/img/indexBuy/alianqiu-f.png'
        },
        {
          country: 6,
          url: '/static/img/indexBuy/jieke.png?v=1',
          flagUrl: '/static/img/indexBuy/jieke-f.png'
        },
        {
          country: '',
          url: '/static/img/indexBuy/more.png?v=1',
          flagUrl: ''
        }
      ],
      priceList1: [
        {
          country: 102,
          url: '/static/img/indexBuy/bz.png?v=0',
          flagUrl: '/static/img/indexBuy/bz-f.png'
        },
        {
          country: 103,
          url: '/static/img/indexBuy/dc.png',
          flagUrl: '/static/img/indexBuy/dc-f.png'
        },
        {
          country: 101,
          url: '/static/img/indexBuy/we.png',
          flagUrl: '/static/img/indexBuy/we-f.png'
        },
        {
          country: 104,
          url: '/static/img/indexBuy/oy.png?v=0',
          flagUrl: '/static/img/indexBuy/oy-f.png'
        },
        {
          country: 102,
          url: '/static/img/indexBuy/fabz.png?v=0',
          flagUrl: '/static/img/indexBuy/fabz-icon.png'
        },
        {
          country: 103,
          url: '/static/img/indexBuy/fa-battery.png?v=0',
          flagUrl: '/static/img/indexBuy/fa-battery-icon.png'
        },
        {
          country: 101,
          url: '/static/img/indexBuy/fa-wee.png?v=0',
          flagUrl: '/static/img/indexBuy/fa-wee-icon.png'
        },
        {
          country: 115,
          url: '/static/img/indexBuy/fa-fangzhi.png?v=0',
          flagUrl: '/static/img/indexBuy/fa-fangzhi-icon.png'
        }
      ],
      url: '/index',
      phoneValue: '',
      slider: '#duoge1',
      liderValidation: false,
      windowHeight: '',
      codeNumber: false,
      codeButton: '发送验证码',
      codeMsgValue: '',
      passWordValue: '',
      surePwd: '',
      time: 60,
      agree: false,
      checkChannelFlag: true,
      aliCode: {},
      scrollTop: false,
      toast1: null,
      images: undefined,
      phoneInfo: ''
    }
  },
  components: { Header, slider },
  created () {
    let phone = navigator.userAgent // 设备机型的相关信息
    this.phoneInfo = phone.substring(
      phone.indexOf('(') + 1,
      phone.indexOf(';')
    ) // 处理信息，输出phone
    this.getImgList()
    this.windowHeight = document.documentElement.clientHeight
    // 流量监控
    // let a = document.createElement("script");
    // a.src = "https://hm.baidu.com/hm.js?86ceba52022e26a7fddef7e6e0c626e4";
    // let b = document.getElementsByTagName("script")[0];
    // b.parentNode.insertBefore(a, b);
    document.title = '欧税通—跨境电商一站式VAT税务服务平台'
    document.documentElement.scrollTop = 0

    if (localStorage.getItem('zhuce')) {
      let nowTime = parseInt(
        60 -
          (new Date().getTime() - localStorage.getItem('zhuce').toString()) /
            1000
      ) // 对比时间戳判断倒计时是否结束
      if (nowTime < 0) {
        // 倒计时结束
        this.codeNumber = false
        this.codeButton = '发送验证码'
        localStorage.removeItem('zhuce')
      } else {
        this.codeNumber = true
        this.time = nowTime
        this.codeTime()
      }
    }
    let locationHref = window.location.href
    if (locationHref.indexOf('?') > -1) {
      locationHref = decodeURI(locationHref)
      let param = ''
      if (locationHref.indexOf('&') > -1) {
        let params = locationHref.substring(
          locationHref.indexOf('?') + 1,
          locationHref.indexOf('&')
        )
        param = params.split('=')[1]
      } else {
        param = locationHref
          .substring(locationHref.indexOf('?') + 1)
          .split('channelNo=')[1]
      }
      this.aliCode.channelCode = param
    }
    if (this.aliCode.channelCode) {
      this.channel()
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  destroyed () {
  },
  watch: {
    $route () {
      if (this.toast1) {
        this.toast1.clear()
        this.toast1 = ''
      }
    }
  },
  methods: {
    getImgList () {
      getSysPosterConfigList({ module: 2, status: 1 })
        .then(res => {
          if (res.code == 0) {
            if (res.rows && res.rows.length > 0) {
              res.rows.sort(function (a, b) {
                return a.sort - b.sort
              })
              let list = []
              res.rows.forEach(i => {
                list.push({
                  posterId: i.posterId,
                  incrViewCount: 1
                })
              })
              adRecordBanner(list).then()
              this.images = res.rows
            }
          } else {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          }
        })
        .catch(() => {
          this.$toast({ message: '系统繁忙，请稍后重试' })
        })
    },
    tolink (e) {
      if (e.showType == '1') {
        adRecordBanner([{ posterId: e.posterId, incrClickCount: 1 }]).then()
        let href = e.showWay
        if (href.indexOf('http') != -1 || href.indexOf('https') != -1) {
          window.open(e.showWay, '_blank')
        } else {
          // if (href.indexOf('?type=') != -1) {
          //   this.$router.push({name: href.split('?type=')[0],query:{type:href.split('?type=')[1]}})
          // } else {
          //   this.$router.push({name: href})
          // }
          if (
            this.phoneInfo.indexOf('Windows') != -1 ||
            this.phoneInfo.indexOf('Macintosh') != -1
          ) {
            this.$toast({ message: '请用手机端打开' })
          } else {
            linkToProgram({ path: href })
              .then(res => {
                if (res.code == 0) {
                  window.location.href = res.data
                } else {
                  this.$toast({ message: '系统繁忙，请稍后重试' })
                }
              })
              .catch(() => {
                this.$toast({ message: '系统繁忙，请稍后重试' })
              })
          }
        }
      }
    },
    scrollToTop () {
      setTimeout(() => {
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }, 300)
    },
    handleScroll: throttle(function () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      console.log(scrollTop)
      if (scrollTop > 500) {
        this.scrollTop = true
      } else {
        this.scrollTop = false
      }
    }, 500),
    toBuy (item) {
      item = JSON.parse(JSON.stringify(item))
      let typeId = ''
      let searchTitleValue = ''
      if (item.country > 100) {
        searchTitleValue = 'OD'
        item.country = ''
        typeId = 1
      } else {
        searchTitleValue = 'VAT'
        typeId = 0
      }
      if (
        this.phoneInfo.indexOf('Windows') != -1 ||
        this.phoneInfo.indexOf('Macintosh') != -1
      ) {
        window.location.href = `https://user.evatmaster.com/buy?typeId=${typeId}&country=${item.country}`
      } else {
        linkToProgram({
          path: 'pages/buy/buy',
          searchTitleValue,
          countryValue: item.country
        })
          .then(res => {
            if (res.code == 0) {
              window.location.href = res.data
            } else {
              this.$toast({ message: '系统繁忙，请稍后重试' })
            }
          })
          .catch(() => {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          })
      }
    },
    ...mapActions(['GetInfo']),
    showPopup () {
      this.show = true
    },
    /**
     * @description 去登陆
     */
    toLogin () {
      if (
        this.phoneInfo.indexOf('Windows') != -1 ||
        this.phoneInfo.indexOf('Macintosh') != -1
      ) {
        window.location.href = 'https://user.evatmaster.com/buy'
      } else {
        linkToProgram({ path: 'pages/logs/logs' })
          .then(res => {
            if (res.code == 0) {
              window.location.href = res.data
            } else {
              this.$toast({ message: '系统繁忙，请稍后重试' })
            }
          })
          .catch(() => {
            this.$toast({ message: '系统繁忙，请稍后重试' })
          })
      }
    },
    /**
     * @description 检验channelNo
     */
    channel () {
      channelNo({ channelId: this.aliCode.channelCode })
        .then(res => {
          if (res.code == 0) {
            if (!(res.rows.length > 0)) {
              this.$toast({
                message: `该注册码(${this.aliCode.channelCode}获取到的渠道码)有误，请联系您的客服经理`
              })
              this.checkChannelFlag = false
              this.$emit('channelNo', 'false')
            } else {
              this.$emit('channelNo', 'true')
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    /**
     * @description 用户协议
     */
    agreeClick () {
      this.agree = !this.agree
    },
    /**
     *@description 获取验证码的点击事件
     */
    getVerificationCode () {
      // 手机号为空
      if (this.phoneValue === '') {
        this.$toast({ message: '请输入手机号' })
        return
      }
      // 手机号格式不对
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$toast({ message: '请输入正确的手机号' })
        return
      }
      this.liderValidation = true
      if (this.liderValidation) {
        this.$refs.slider.getScroll()
      }
    },
    /**
     *@description 滑块验证通过
     */
    sliderSuccess (e) {
      if (e !== 'error') {
        this.aliCode = e
        let land5 = new Date().getTime()
        localStorage.setItem('zhuce', land5)
        this.codeTime()
      }
      setTimeout(() => {
        this.liderValidation = false
      }, 500)
    },
    /**
     *@description 获取验证码的button显示
     */
    codeTime () {
      this.codeNumber = true
      let interval = setInterval(() => {
        this.codeButton = `${this.time}s`
        if (this.time-- <= 0) {
          this.codeNumber = false
          this.codeButton = '发送验证码'
          this.time = 60
          window.clearInterval(interval)
        }
      }, 1000)
    },
    /**
     * 立即注册的点击事件
     */
    registerNow: debounce(function () {
      // 校验手机号为空
      if (this.phoneValue === '') {
        this.$toast({ message: '请输入手机号' })
        return
      }
      // 校验 手机号格式
      if (!/^[1][0-9]{10}$/.test(this.phoneValue)) {
        this.$toast({ message: '请输入正确的手机号' })
        return
      }
      // 校验验证码为空
      if (this.codeMsgValue === '') {
        this.$toast({ message: '请输入验证码' })
        return
      }
      // 校验密码为空
      if (this.passWordValue === '') {
        this.$toast({ message: '请输入密码' })
        return
      }
      // 校验密码格式错误
      if (
        !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,18}$/.test(this.passWordValue)
      ) {
        this.$toast({ message: '密码至少有一位数字和字母,6-18位字母数字组合' })
        return
      }
      if (this.surePwd === '') {
        this.$toast({
          message: '请输入确认密码'
        })
        return
      }
      if (this.surePwd !== this.passWordValue) {
        return this.$toast({ message: '两次输入的密码不一致，请检查后注册' })
      }
      // 校验协议
      if (!this.agree) {
        this.$toast({
          message: '请阅读并同意《用户服务协议》和《隐私及信息保护政策》'
        })
        return
      }
      if (!this.checkChannelFlag) {
        this.$toast({
          message: `该注册码(${this.aliCode.channelCode}获取到的渠道码)有误，请联系您的客服经理`
        })
        return
      }
      this.aliCode.smscode = this.codeMsgValue
      this.aliCode.password = window.btoa(this.passWordValue)
      this.aliCode.phonenumber = this.phoneValue
      if (this.$route.query.channelNo) {
        this.aliCode.channelCode = this.$route.query.channelNo
      } else {
        this.aliCode.channelCode = getCookie('channelCode')
      }
      let headers = {
        processData: 'false',
        contentType: 'false'
      }
      this.toast1 = this.$toast.loading({
        message: '登陆中...',
        forbidClick: true
      })
      setTimeout(() => {
        if (this.toast1) {
          this.toast1.clear()
          this.toast1 = ''
        }
      }, 15000)
      registered(this.aliCode, headers)
        .then(res => {
          let h = window.location.href
          let d = process.env.NODE_MODE === 'development' ? document.domain : document.domain.split('.').slice(-2).join('.')
          let href = 'https://user.evatmaster.com'
          if (h.indexOf('uat') != -1) {
            href = 'https://uat-user.evatmaster.com'
          } else if (h.indexOf('ost.com') != -1) {
            href = 'http://mc1.ost.com'
          }
          if (res.code == 500) {
            if (res.msg == '账号已存在') {
              this.$dialog
                .confirm({
                  message:
                    '您已注册麦德通，快去登录看看吧~',
                  confirmButtonText: '我知道了',
                  showCancelButton: false
                })
            } else {
              this.$toast({ message: res.msg })
            }
          } else if (res.code == 0) {
            this.$dialog
              .confirm({
                message: '注册成功！快去登录看看吧～',
                confirmButtonText: '我知道了',
                showCancelButton: false
              })
              .then(() => {
                if (
                  this.phoneInfo.indexOf('Windows') != -1 ||
                  this.phoneInfo.indexOf('Macintosh') != -1
                ) {
                  document.cookie = `h5Token=${res.token};path=/;domain=${d}`
                  window.location.href = `${href}/workPlace`
                } else {
                  linkToProgram({
                    path: 'minePages/pages/loginLoading/index',
                    formType: 'h5',
                    phone: this.phoneValue,
                    toPage: '/pages/homes/homes'
                  })
                    .then(res => {
                      if (res.code == 0) {
                        window.location.href = res.data
                      } else {
                        this.$toast({ message: '系统繁忙，请稍后重试' })
                      }
                    })
                    .catch(() => {
                      this.$toast({ message: '系统繁忙，请稍后重试' })
                    })
                }
              })
          }
        })
        .catch(error => {
          this.$toast({ message: '系统错误，请稍后重试' })
          setTimeout(() => {
            this.toast1.clear()
            this.toast1 = ''
          }, 3000)
        })
        .finally(() => {
          this.toast1.clear()
          this.toast1 = ''
        })
    }, 500)
  }
}
</script>

<style scoped>
.list-img {
  float: left;
  width: 25%;
  height: 211px;
}
.list-img2 {
  height: 230px;
}
.to-top {
  position: fixed;
  width: 1rem !important;
  right: 5px;
  bottom: 148px;
  height: 1rem !important;
  display: inline-block;
  border-radius: 100%;
  background: white;
  box-shadow: 10px 10px 70px gray;
}
.to-top img {
  width: 100%;
}
.maskStyle {
  background: rgba(0, 0, 0, 0.6);
  z-index: 8;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}
.maskStyle p {
  text-align: left;
  height: 35px;
  line-height: 35px;
  margin: 8px 0;
  color: red;
  padding-left: 15px;
}
.banner {
  display: inline-block;
  width: 100%;
  height: 100%;
}
.index {
  width: 100%;
}
.index img {
  width: 100%;
}
input {
  border: none;
  outline: none;
}
.content {
  width: 90%;
  margin: 0.5rem auto;
  box-shadow: 0px 0px 40px 0px rgba(102, 102, 102, 0.07);
  border-radius: 10px;
  padding: 0.5rem;
}
.title {
  font-size: 0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(11, 167, 255, 1);
  border: 1px solid rgba(11, 167, 255, 0.2);
  border-radius: 10px;
  width: 4.5rem;
  padding: 0.1rem 0;
  margin: 0 auto 0.5rem;
}
.btnClick {
  height: 0.84rem;
  background: rgba(11, 167, 255, 1);
  border-radius: 0.1rem;
  font-size: 0.36rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 0.84rem;
  margin-top: 0.4rem;
}
img {
  display: inline-block;
}
.send-code {
  height: 0.55rem;
  background: rgba(11, 167, 255, 1);
  border-radius: 0.1rem;
  line-height: 0.55rem;
  padding: 0 0.1rem;
  font-size: 0.22rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(254, 255, 255, 1);
}
.ipt-div {
  display: flex;
  height: 0.7rem;
  margin: 0.25rem 0;
}
.ipt-div div {
  border-bottom: 1px solid lightgray;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: 0.2rem;
}
.icon-span {
  position: relative;
  display: inline-block;
  width: 0.5rem;
  height: 100%;
}
.icon-span img {
  position: absolute;
  width: 100%;
  bottom: 0.1rem;
  left: 0;
}
.agree {
  position: relative;
  display: flex;
  font-size: 0.2rem;
  padding-left: 0.3rem;
}
.radius1 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  border: 1px solid rgba(11, 167, 255, 1);
}
.radius2 {
  /* position: absolute;
  bottom: 0.08rem; */
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 100%;
  background: rgba(11, 167, 255, 1);
}
.check {
  display: inline-block;
  width: 0.25rem;
  height: 0.25rem;
  position: absolute;
  top: 50%;
  margin-top: -0.125rem;
  left: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue